<template>
  <div class="body">
    <el-container>
      <!-- <Aside @toggle="toggle($event)" /> -->
      <el-main>
        <el-card>
          <div slot="header" class="clearfix">
            <span>الإعدادات</span>
          </div>
          <el-card class="printing-card">
            <div slot="header" class="clearfix">
              <span>اعدادات الطباعه</span>
            </div>
            <el-radio-group v-model="printingType" @change="saveMode">
              <el-radio :label="true">طباعه فاتورة كبيره</el-radio>
              <el-radio :label="false"> طباعه فاتورة صغيره</el-radio>
            </el-radio-group>
          </el-card>
        </el-card>
        <el-card>
          <div slot="header" class="clearfix">
            <span>تغيير logo </span>
          </div>
          <form id="myForm" name="myForm">
            <el-row>
              <el-col :lg="12" :md="24" class="upload">
                <el-row
                  align="middle"
                  :gutter="10"
                  style="align-items: flex-end"
                >
                  <el-col :span="14">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                  </el-col>
                  <el-col :span="5">
                    <el-upload
                      class="avatar-uploader"
                      ref="upload"
                      action="https://pos.staging.fatura-app.com/api/branches/1"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :auto-upload="false"
                      :on-change="handlePreview"
                      :on-error="handleError"
                    >
                      <el-button size="small" type="primary"
                        >تحميل صوره</el-button
                      >
                    </el-upload>
                  </el-col>
                  <el-col :span="5">
                    <div>
                      <el-button
                        v-if="show"
                        size="small"
                        type="warning"
                        @click="submitUpload"
                        >حفظ</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </form>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Aside from "@/components/aside.vue";
// import axiosApi from "@/plugins/axios.js";
export default {
  components: { Aside },
  data() {
    return {
      printingType: localStorage.getItem("printingType")
        ? JSON.parse(localStorage.getItem("printingType"))
        : true,
      imageUrl:
        "https://pos.staging.fatura-app.com" +
        JSON.parse(localStorage.getItem("branch")).logo,
      img:
        "https://pos.staging.fatura-app.com" +
        JSON.parse(localStorage.getItem("branch")).logo,
      loading: null,
      show: false,
    };
  },
  methods: {
    saveMode() {
      localStorage.setItem("printingType", JSON.stringify(this.printingType));
    },
    handleError(){
      this.show = false;
      this.loading.close();
    },
    uploadImage() {
      let myForm = document.getElementById("myForm");
      let form = new FormData(myForm);
      console.log(form);
      console.log(myForm);
      // console.log("logo", this.form);
      // fetch("http://22a2-197-39-162-170.ngrok.io/api/branches/1", {
      //   method: "PUT",
      //   body: { logo: this.form.logo },
      // }).then((res) => {
      //   console.log(res);
      // });
      // axiosApi.put(`branches/1`,this.form).then((res)=>{
      //   console.log("logo res",res);
      // }).catch((err)=>{
      //   console.log("logo err",err);
      // })
    },
    handleAvatarSuccess(res, file) {
      this.show = false;
      this.loading.close();
      this.imageUrl = URL.createObjectURL(file.raw);
      this.img = URL.createObjectURL(file.raw);
      localStorage.setItem("branch", JSON.stringify(res.branches[0]));
      console.log(res);
    },
    submitUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "جاري حفظ الصورة",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$refs.upload.submit();
    },
    handlePreview(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.show = true;
    },
    beforeAvatarUpload(file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
  },
  mounted() {},
  watch: {
    img: function() {
      this.show = false;
    }
  }
};
</script>

<style lang="scss">
.printing-card {
  width: 190px;
  .el-radio-group {
    display: block !important;
    .el-radio {
      display: block !important;
      &:first-child {
        margin: 0 0 12px;
      }
      .el-radio__label {
        margin-right: 5px;
      }
    }
  }
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
